import cx from 'classnames';
import React from 'react';
import styles from './thumbnail.module.scss';
import { ThumbnailBackground } from './thumbnail-background';

export interface ThumbnailProps {
  /**
   * Unique Id
   */
  id?: string;

  /**
   * Class Names for thumbnail
   */
  className?: string;

  /**
   * Background Color - Can be single color or gradient
   * @default '#FFFFFF'
   */
  backgroundColor?: string | string[];

  /**
   * Display Text for thumbnail
   * @default 'Aa'
   */
  displayText?: string;

  /**
   * Color for displayed text
   * @default '#1c2330'
   */
  textColor?: string;

  /**
   * Font styles to be applied
   * @default []
   */
  fontStyles?: FontStyles[];
}

export enum FontStyles {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE_THROUGH = 'strike-thorugh',
}

export const Thumbnail: React.FC<ThumbnailProps> = ({
  id,
  className,
  backgroundColor = '#FFFFFF',
  displayText = 'Aa',
  textColor,
  fontStyles = [],
}: ThumbnailProps) => {
  const thumbnailWrapperClass = cx(styles.thumbnailWrapper, className);
  const textColorClass = { color: textColor };
  const fontStylesClass = cx({
    [styles.bold]: fontStyles.includes(FontStyles.BOLD),
    [styles.italic]: fontStyles.includes(FontStyles.ITALIC),
    [styles.underline]: fontStyles.includes(FontStyles.UNDERLINE),
    [styles.strikeThrough]: fontStyles.includes(FontStyles.STRIKE_THROUGH),
    [styles.underlineAndStrike]:
      fontStyles.includes(FontStyles.UNDERLINE) && fontStyles.includes(FontStyles.STRIKE_THROUGH),
  });

  return (
    <div id={id} className={thumbnailWrapperClass}>
      <div className={styles.displayTextWrapper}>
        <span style={textColorClass} className={fontStylesClass}>
          {displayText}
        </span>
      </div>
      {ThumbnailBackground(backgroundColor)}
    </div>
  );
};
